export default __webpack_public_path__ + "static/media/smartphone.3252c409.png";